// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xh2P","inner":"styles_inner__3z75w","right":"styles_right__1HPs7","close":"styles_close__3v7Yv","footer":"styles_footer__qCIjR"};